import "core-js/modules/es.promise"

import HrFilter from "landingpage/hrfilter"

import $ from "jquery"

import "utils/axios"
import Automount from "utils/automount"

$(document).ready(() => {
  Automount("hrfilter-app", HrFilter)
})
